/**
 * W1a, scherm Koppelingen (opdracht Frank 22 okt, besluit 23 okt: een groot venster
 * vanuit het menu, geen route in App.js). Dit is wat het tabblad Ontdekken aanbiedt,
 * plus de twee pure keuzes die het venster maakt: wat past bij het zoekveld, en of een
 * adres al gekoppeld is.
 *
 * De eerste koppeling is Franks eigen Direkto-server. De omschrijving zegt alleen wat
 * de server zelf over zichzelf zegt; bestellen en betalen gebeurt bij de winkel.
 */
export const CATALOGUS = [
  {
    id: "direkto",
    naam: "Direkto",
    adres: "https://mcp.direkto.org/mcp",
    omschrijving: "Meerdere aangesloten webwinkels: producten zoeken, offertes en bestellinks. Bestellen en betalen doe je bij de winkel.",
  },
  // W4 (besluit Frank 24 oktober 2026): GitHub ALLEEN LEZEN, met een token dat Frank zelf
  // invult. Het adres eindigt op /readonly: de server van GitHub biedt dan alleen
  // leesgereedschap aan (docs/remote-server.md van github/github-mcp-server, gelezen op
  // 24 oktober). Het token gaat als Bearer mee, versleuteld opgeslagen, nooit teruggegeven.
  {
    id: "github",
    naam: "GitHub (alleen lezen)",
    adres: "https://api.githubcopilot.com/mcp/readonly",
    omschrijving: "Je repositories, issues en pull requests lezen. Alleen lezen: schrijven kan deze koppeling niet. Vul een eigen GitHub-token in.",
    sleutelNodig: true,
  },
];

/** Een adres zoals twee schrijfwijzen van hetzelfde adres gelijk uitkomen. PUUR. */
export function zelfdeAdres(a) {
  const tekst = String(a || "").trim();
  try {
    const u = new URL(tekst);
    // `URL` zet de host al in kleine letters; alleen de slash achteraan gaat eraf.
    return `${u.protocol}//${u.host}${u.pathname.replace(/\/+$/, "")}${u.search}`;
  } catch {
    return tekst.replace(/\/+$/, "").toLowerCase();
  }
}

/** Staat dit adres al bij de actieve koppelingen? Een ontkoppelde telt niet. PUUR. */
export function alGekoppeld(adres, servers) {
  const doel = zelfdeAdres(adres);
  return (servers || []).some((s) => s.actief !== false && zelfdeAdres(s.adres) === doel);
}

/**
 * Wat bij het zoekveld past: hoofdletterongevoelig op elk genoemd veld, en een leeg
 * veld geeft alles terug, niet niets. `velden` zijn functies, zodat een vertaalde
 * omschrijving meetelt in de taal die de persoon leest. PUUR.
 */
export function zoekIn(lijst, zoek, velden) {
  const z = String(zoek || "").trim().toLowerCase();
  if (!z) return [...(lijst || [])];
  return (lijst || []).filter((item) => velden.some((veld) => String(veld(item) || "").toLowerCase().includes(z)));
}
